import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { useCompetitionGroupListQuery } from '../queries';
import { useDeleteGroupMutation } from '../mutations';
import { Table } from '~/components/Table/Table';
import { Panel } from '~/components/Panel/Panel';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { idParamSchema } from '~/schemas';
import { Group } from '~/apis/ssf';
import { formatDate } from '~/utils/date';

function Row({ group, onDelete }: { group: Group; onDelete: (id: number) => void }) {
  return (
    <Table.Row>
      <Table.Col>{group.name}</Table.Col>
      <Table.Col>{group.start ? formatDate(new Date(group.start), 'yyyy-mm-dd') : '-'}</Table.Col>
      <Table.Col align="right">
        <Table.Context
          items={[<ContextMenu.Item label="Ta bort" key="delete" onClick={() => onDelete(group.id)} danger />]}
        />
      </Table.Col>
    </Table.Row>
  );
}

export function GroupsListTable() {
  const { id } = useParams(idParamSchema.parse);
  const { data, isLoading } = useCompetitionGroupListQuery({ competition: id });

  const deleteMutation = useDeleteGroupMutation();

  async function handleDelete(id: number) {
    await deleteMutation.mutateAsync(id);
  }

  if (!isLoading && data?.results.length === 0) {
    return (
      <Panel variant="informative" size="sm">
        <p>Inga grupper är skapade ännu. Skapa en grupp i formuläret ovan för att komma igång.</p>
      </Panel>
    );
  }

  return (
    <Fragment>
      <Table bg="even">
        <Table.Head>
          <Table.Row>
            <Table.Col as="th">Namn</Table.Col>
            <Table.Col as="th">Datum</Table.Col>
            <Table.Col as="th" />
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {isLoading ? (
            <Table.Loading cols={12} />
          ) : (
            data?.results.map(group => <Row group={group} key={group.id} onDelete={handleDelete} />)
          )}
        </Table.Body>
      </Table>
    </Fragment>
  );
}
